// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width: 600px){.inputBox{width:80% !important}}", "",{"version":3,"sources":["webpack://./src/css/Login.css"],"names":[],"mappings":"AAAA,yBACC,UACC,oBAAA,CAAA","sourcesContent":["@media (max-width: 600px) {\n\t.inputBox {\n\t\twidth: 80% !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
